export default __webpack_public_path__ + "static/media/detail_page_icon.0f63846c.svg";